document.addEventListener("DOMContentLoaded", () => {

    const cards = document.querySelectorAll(".pf1-card");

    if (!cards.length) return;

    /* -----------------------------
       Reveal Animation
    ------------------------------ */

    const observer = new IntersectionObserver((entries)=>{

        entries.forEach(entry=>{

            if(entry.isIntersecting){

                entry.target.classList.add("pf1-show");

                observer.unobserve(entry.target);

            }

        });

    },{

        threshold:0.2

    });

    cards.forEach((card,index)=>{

        card.style.transitionDelay = (index * .12) + "s";

        observer.observe(card);

    });

    /* -----------------------------
       Floating Icon
    ------------------------------ */

    cards.forEach(card=>{

        const icon = card.querySelector(".pf1-icon");

        if(!icon) return;

        let direction = 1;

        let offset = 0;

        function animate(){

            offset += 0.15 * direction;

            if(offset >= 6) direction = -1;

            if(offset <= -6) direction = 1;

            icon.style.transform = `translateY(${offset}px)`;

            requestAnimationFrame(animate);

        }

        animate();

    });

});